import { useThunkDispatch } from 'store/hooks'
import { Notice, Severity, addNotification } from 'widget/Notifications'

// Добавление уведомления с Timeou
export const useSetTimeoutNotice = () => {
  const thunkDispatch = useThunkDispatch()

  const updateNotice = (text: string, severity: Severity) => {
    const notice: Notice = {
      text: text,
      severity: severity,
    }

    setTimeout(() => {
      thunkDispatch(addNotification(notice))
    }, 300)
  }

  return updateNotice
}
